import { useEffect, useRef } from 'react';
import { API_BASE } from '@/lib/api';

/**
 * Subscribe to tenant SSE stream.
 * handlers: { message_in: (data) => {}, notification: (data) => {}, connected: () => {} }
 */
export function useRealtime(handlers = {}, enabled = true) {
  const handlersRef = useRef(handlers);
  handlersRef.current = handlers;

  useEffect(() => {
    if (!enabled) return undefined;
    const tok = localStorage.getItem('zunoid_access');
    if (!tok) return undefined;

    let es;
    let closed = false;
    let retryTimer;

    const connect = () => {
      if (closed) return;
      const url = `${API_BASE}/events/stream?token=${encodeURIComponent(tok)}`;
      try {
        es = new EventSource(url);
      } catch {
        retryTimer = setTimeout(connect, 8000);
        return;
      }

      es.addEventListener('connected', () => {
        handlersRef.current.connected?.({});
      });

      const types = ['message_in', 'notification', 'campaign', 'message'];
      types.forEach((t) => {
        es.addEventListener(t, (ev) => {
          try {
            const data = JSON.parse(ev.data || '{}');
            handlersRef.current[t]?.(data);
            handlersRef.current.any?.({ type: t, data });
          } catch {
            /* ignore */
          }
        });
      });

      es.onerror = () => {
        try { es.close(); } catch { /* ignore */ }
        if (!closed) retryTimer = setTimeout(connect, 5000);
      };
    };

    connect();
    return () => {
      closed = true;
      if (retryTimer) clearTimeout(retryTimer);
      try { es?.close(); } catch { /* ignore */ }
    };
  }, [enabled]);
}
